/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { FC } from "react";
import { Snackbar, Slide, SlideProps, Typography, Alert } from "@mui/material";
import { styled } from "@mui/material/styles";

const SlideTransition: FC<SlideProps> = (props) => {
  return (
    <Slide
      {...props}
      direction="down"
      timeout={{
        appear: 500,
        enter: 300,
        exit: 500,
      }}
    />
  );
};

const CustomAlert = styled(Alert)(({ theme }) => ({
  backgroundColor: "white",
  border: "solid",
  borderWidth: "1px",
  borderColor: "black",
  width: "40vw",
  display: "flex",
  justifyContent: "center",
}));

interface TaskCompleteAlertProps {
  isOpen: boolean;
  onClose: () => void;
  label: string;
}

export const TaskCompleteAlert: FC<TaskCompleteAlertProps> = ({
  isOpen,
  onClose,
  label,
}) => {
  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      open={isOpen}
      autoHideDuration={3000}
      key={"topcenter"}
      sx={{ mt: 8 }}
      onClose={onClose}
      TransitionComponent={SlideTransition}
    >
      <CustomAlert icon={false} variant="outlined">
        <Typography variant="h5">{label}</Typography>
      </CustomAlert>
    </Snackbar>
  );
};
